import { render, staticRenderFns } from "./IconSvgVolumeUp.vue?vue&type=template&id=fa40c0c4&scoped=true&"
import script from "./IconSvgVolumeUp.vue?vue&type=script&lang=js&"
export * from "./IconSvgVolumeUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa40c0c4",
  null
  
)

export default component.exports